import React, { useState, useEffect } from "react";
import { TimerResponse } from "../../hooks/patients/useFloatingTimer";
import styles from "./Accordion.module.css";

interface FloatingTimerProps {
  floatingTimer: TimerResponse | undefined;
}

const FloatingTimer: React.FC<FloatingTimerProps> = ({ floatingTimer }) => {
  const [timerValue, setTimerValue] = useState("00:00:00");

  useEffect(() => {
    if (!floatingTimer) return;

    let interval: NodeJS.Timeout;

    const updateTimer = () => {
      try {
        const startTime = new Date(
          floatingTimer.data?.startTimerTimestampUtc ||
            floatingTimer.data?.startTimerLocal
        ).getTime();

        if (isNaN(startTime)) {
          setTimerValue("00:00:00");
          return;
        }

        const now = Date.now();
        const elapsed = Math.floor((now - startTime) / 1000);

        const hours = Math.floor(elapsed / 3600);
        const minutes = Math.floor((elapsed % 3600) / 60);
        const seconds = elapsed % 60;

        setTimerValue(
          `${hours.toString().padStart(2, "0")}:${minutes
            .toString()
            .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
        );
      } catch (error) {
        console.error("Error updating timer:", error);
        setTimerValue("00:00:00");
      }
    };

    updateTimer();
    interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [floatingTimer]);

  if (!floatingTimer?.data) return null;

  return (
    <div className={styles.floatingCard}>
      <div className={styles.timerValue}>{timerValue}</div>

      <div className={styles.patientRow}>
        <span className={styles.patientName}>
          {floatingTimer.data?.patientId.name || "-"}
        </span>
      </div>
    </div>
  );
};

export default FloatingTimer;
